import React from 'react'
import './_styles.scss'

const landingFooter = () => {
  return (
    <div className='landingFooter'>
      <div className='fullscreenWrapper'>
        &#169; 2021 Nestaway Technologies Pvt Ltd. All rights reserved.
        {/* <img className='image' src={{}} /> */}
      </div>
    </div>
  )
}

export default landingFooter
